"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Foundation_1 = require("../../Foundation");
var Text_view_1 = require("./Text.view");
var Text_styles_1 = require("./Text.styles");
exports.Text = Foundation_1.createComponent({
    displayName: 'Text',
    styles: Text_styles_1.TextStyles,
    view: Text_view_1.TextView
});
exports.default = exports.Text;
//# sourceMappingURL=Text.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Text/Text.js
// module id = 1221
// module chunks = 0